import { jsx as _jsx } from "react/jsx-runtime";
import { DisconnectOutlined } from "@ant-design/icons";
import { App, Button, Popconfirm, Tooltip } from "antd";
import { observer } from "mobx-react";
import { __ } from "../../../utils/i18n.js";
const PluginUpdateClearClientUuidButton = observer(({ license })=>{
    const { message } = App.useApp();
    const { uuid, busy } = license;
    if (!uuid) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: __("Installation ID: %s. Reset it so the next activation registers this WordPress site as a new installation in the Customer Center. This can help after copying a site (for example staging).", uuid),
        children: /*#__PURE__*/ _jsx(Popconfirm, {
            placement: "bottomRight",
            overlayStyle: {
                maxWidth: 320
            },
            title: __("Reset installation ID?"),
            description: __("The next license activation will register this WordPress site as a new installation in the Customer Center. Use this after copying a site (for example staging) when domains get mixed up."),
            okText: __("Reset installation ID"),
            cancelText: __("Cancel"),
            onConfirm: async ()=>{
                try {
                    await license.clearClientUuid();
                    message.success(__("Installation ID reset."));
                } catch (e) {
                    message.error(e.responseJSON?.message);
                }
            },
            children: /*#__PURE__*/ _jsx(Button, {
                type: "text",
                size: "small",
                icon: /*#__PURE__*/ _jsx(DisconnectOutlined, {}),
                loading: busy,
                "aria-label": __("Reset installation ID")
            })
        })
    });
});
export { PluginUpdateClearClientUuidButton };
